<template>
  <div>
    <status-bar :status="status"></status-bar>
    <Answer
    ref="answerCom"
    :class="classObject"
    @answerEnd="onAnswerEnd"
    @refresh="onRefresh"
    ></Answer>
    <Fail
    :precent="precent"
    :class="failView?'':'hide'"
    @refresh="onRefresh"
    ></Fail>
    <Success :class="succView?'':'hide'"></Success>
    <div class="default-info" v-if="defaultInfo.phone||defaultInfo.address">
      <div v-if="defaultInfo.phone">如有疑问请联系当地分公司：<span>{{ defaultInfo.phone}}</span></div>
      <div v-if="defaultInfo.address">联系地址：{{ defaultInfo.address }}</div>
    </div>
    <div class="default-info"  v-else>
      <div class="tips">
          {{defaultInfo.default_text}}<span>{{defaultInfo.default}}</span>
        </div>
    </div>
  </div>
</template>
<script>
import StatusBar from '../../components/StatusBar'
import Answer from './components/Answer'
import Fail from './components/Fail'
import Success from './components/Success'
import {changeHistory} from '../../utils/common'
import { getCompanyInfo } from '../../utils/actions'
export default {
  name: 'recruitAnswer',
  components: {
    StatusBar,
    Answer,
    Success,
    Fail
  },
  data () {
    return {
      status: '',
      precent: '',
      failView: false,
      succView: false,
      defaultInfo: {}
    }
  },
  created () {
    this.status = this.$route.params.status
    changeHistory()
    getCompanyInfo({
      city_id: this.$store.state.cityId || '1'
    }).then((res) => {
      this.defaultInfo = res.data
      console.log(this.defaultInfo)
    })
  },
  mounted () {
    var that = this
    switch (that.status) {
      case '2':
        that.failView = false
        that.succView = false
        break
      case '3':
        that.failView = true
        break
      case '4':
        that.succView = true
        break
    }
  },
  methods: {
    onRefresh () {
      var that = this
      this.$refs.answerCom.getExamInfo().then(function () {
        that.failView = false
        that.succView = false
      })
    },
    onAnswerEnd (data) {
      if (data.right < data.total) {
        this.failView = true
        this.precent = data.right + '/' + data.total
      } else {
        this.succView = true
      }
    }
  },
  computed: {
    classObject: function () {
      return {
        hide: this.failView || this.succView
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.default-info {
  position: fixed;
  bottom: .4rem;
  left: 0;
  right: 0;
  width: 95%;
  margin: 0 auto;
  text-align: center;
  color: #19191A;
  line-height: .34rem;
  font-size: .24rem;
  div {
    span {
      color: #2A2AFF;
    }
  }
}
.tips {
  text-align: center;
  font-size: .24rem;
  font-weight: 400;
  color: #19191A;
  line-height: .34rem;
  span {
    color: #2A2AFF;
  }
}
// .hide{
//   display: none
// }
// .show{
//   display: block;
// }
</style>



// WEBPACK FOOTER //
// src/pages/recruit-answer/index.vue